module.exports = __webpack_public_path__ + "media/img/frostroomhead-ff035070.jpg";